import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';

interface GridProps {
  children: React.ReactNode;
  className?: string;
  cols?: 1 | 2 | 3 | 4;
  gap?: number;
  animate?: boolean;
}

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 }
};

export function Grid({ children, className, cols = 3, gap = 8, animate = true }: GridProps) {
  const GridComponent = animate ? motion.div : 'div';
  const ItemComponent = animate ? motion.div : 'div';

  return (
    <GridComponent
      variants={container}
      initial={animate ? "hidden" : undefined}
      animate={animate ? "show" : undefined}
      className={clsx(
        'grid gap-' + gap,
        {
          'md:grid-cols-1': cols - 1 === 1,
          'md:grid-cols-2': cols - 1 === 2,
          'md:grid-cols-3': cols - 1 === 3,
          'md:grid-cols-4': cols - 1 === 4,
          'lg:grid-cols-1': cols === 1,
          'lg:grid-cols-2': cols === 2,
          'lg:grid-cols-3': cols === 3,
          'lg:grid-cols-4': cols === 4,
        },
        className
      )}
    >
      {React.Children.map(children, (child) => (
        <ItemComponent variants={animate ? item : undefined}>
          {child}
        </ItemComponent>
      ))}
    </GridComponent>
  );
}